import React from 'react';
import PropTypes from 'prop-types';
import '../cartaGeneral.css';
import '../cartaResto.css';

const ImageContainer = ({ imgLg, imgSm, title, isResto, img }) => {
  if (isResto) {
    return (
      <div className={'sectionImageResto'}>
        <img className={'imageResto'} src={img} alt={title} />
      </div>
    );
  }
  return (
    <>
      {imgLg && (
        <div className={'sectionImage hideOnMobile'}>
          <img src={imgLg} alt={title} />
        </div>
      )}
      {imgSm && (
        <div className={'sectionImage hideOnTabletOrMore'}>
          <img src={imgSm} alt={title} />
        </div>
      )}
    </>
  );
};

ImageContainer.propTypes = {
  imgLg: PropTypes.any,
  imgSm: PropTypes.any,
  img: PropTypes.any,
  title: PropTypes.string,
  isResto: PropTypes.bool.isRequired,
};

export default ImageContainer;
